<div class="kr-layer" v-show="shouldBeDisplayed" ref="content" :class="dynamicClasses"><div class="kr-layer-background"></div></div>